export default {
  'login.title': 'MyStorageX',
  'login.welcome': 'Benvenuto su MyStorageX',
  'login.description': 'MyStorageX è il tuo assistente di archiviazione cloud, che offre archiviazione e gestione dei file sicura e conveniente. Accedi ai tuoi file ovunque e in qualsiasi momento.',
  'login.email.placeholder': 'Email o nome utente',
  'login.password.placeholder': 'Password',
  'login.button': 'Accedi',
  'login.loading': 'Accesso in corso...',
  'login.divider': 'o',
  'login.signup': 'Non hai un account?',
  'login.signup.link': 'Registrati',
  'login.error.default': 'Accesso fallito, riprova più tardi',
  'login.success': 'Accesso effettuato',
  'login.forgotPassword': 'Password dimenticata?',
  'login.forgotPassword.link': 'Reimposta qui',
  'signup.page.title': 'Registrazione - MyStorageX',
  'signup.title': 'MyStorageX',
  'signup.welcome': 'Benvenuto su MyStorageX',
  'signup.description': 'Crea il tuo account e inizia il tuo viaggio di archiviazione cloud',
  'signup.username.placeholder': 'Inserisci nome utente',
  'signup.email.placeholder': 'Inserisci email',
  'signup.password.placeholder': 'Inserisci password',
  'signup.confirmPassword.placeholder': 'Conferma password',
  'signup.button': 'Registrati',
  'signup.loading': 'Registrazione in corso...',
  'signup.login': 'Hai già un account?',
  'signup.login.link': 'Accedi',
  'signup.error.passwordMismatch': 'Le password non corrispondono',
  'signup.error.default': 'Registrazione fallita, riprova più tardi',
  'signup.success': 'Registrazione completata',
  'signup.username.rule.length': 'Il nome utente deve essere compreso tra 4 e 10 caratteri',
  'signup.username.rule.format': 'Sono consentiti solo lettere, numeri, trattini bassi e trattini',
  'signup.password.rule.length': 'La password deve essere compresa tra 6 e 20 caratteri',
  'signup.password.rule.lowercase': 'Deve contenere lettere minuscole',
  'signup.password.rule.uppercase': 'Deve contenere lettere maiuscole',
  'signup.password.rule.number': 'Deve contenere numeri',
  'signup.password.rule.special': 'Deve contenere caratteri speciali',
  'resetPassword.page.title': 'Reimposta password - MyStorageX',
  'resetPassword.page.description': 'Reimposta la password del tuo account MyStorageX',
  'resetPassword.title': 'Reimposta password',
  'resetPassword.email.placeholder': 'Inserisci il tuo indirizzo email',
  'resetPassword.code.placeholder': 'Inserisci il codice di verifica',
  'resetPassword.password.placeholder': 'Inserisci la nuova password',
  'resetPassword.button': 'Reimposta',
  'resetPassword.button.loading': 'Reimpostazione in corso...',
  'resetPassword.backToLogin': 'Torna al login',
  'resetPassword.sendCode': 'Ottieni codice',
  'resetPassword.sendCode.sending': 'Invio in corso...',
  'resetPassword.sendCode.retry': 'Riprova tra {seconds}s',
  'resetPassword.error.emailRequired': 'Inserisci il tuo indirizzo email',
  'resetPassword.error.codeRequired': 'Inserisci il codice di verifica',
  'resetPassword.error.passwordRequired': 'Inserisci la nuova password',
  'resetPassword.error.passwordLength': 'La password deve essere tra 6 e 20 caratteri',
  'resetPassword.error.codeLength': 'Il codice di verifica deve essere di 6 cifre',
  'resetPassword.success.codeSent': 'Il codice di verifica è stato inviato alla tua email',
  'resetPassword.success.reset': 'Password reimpostata con successo',
  'resetPassword.error.sendFailed': 'Errore nell\'invio del codice di verifica, riprova più tardi',
  'resetPassword.error.resetFailed': 'Errore nella reimpostazione della password, riprova più tardi',
  'signup.verificationCode.placeholder': 'Inserisci il codice di verifica',
  'signup.verificationCode.send': 'Ottieni codice',
  'signup.verificationCode.sending': 'Invio in corso...',
  'signup.verificationCode.retry': 'Riprova tra {seconds}s',
  'signup.verificationCode.success': 'Codice di verifica inviato',
  'signup.verificationCode.error': 'Invio del codice fallito',
  'signup.verificationCode.required': 'Inserisci il codice di verifica',
  'signup.verificationCode.invalid': 'Formato del codice di verifica non valido',
  'signup.error.emailRequired': 'Per favore inserisci il tuo indirizzo email',
  'signup.announcement': 'La funzione di registrazione è in manutenzione oggi!',
  'sidebar.allFiles': 'Tutti i file',
  'sidebar.starred': 'Preferiti',
  'sidebar.folders': 'Cartelle',
  'sidebar.trash': 'Cestino',
  'sidebar.decrypt': 'Strumento di decrittazione',
  'sidebar.feedback': 'Feedback',
  'sidebar.about': 'Info',
  'sidebar.productLog': 'Aggiornamenti',
  'filelist.column.name': 'Nome',
  'filelist.column.size': 'Dimensione',
  'filelist.column.updateTime': 'Modificato',
  'filelist.column.recycletime': 'Data eliminazione',
  'filelist.column.actions': 'Azioni',
  'filelist.total': 'Totale {total} elementi',
  'filelist.action.upload': 'Carica',
  'filelist.action.newFolder': 'Nuova cartella',
  'filelist.action.refresh': 'Aggiorna',
  'filelist.action.search': 'Cerca file',
  'filelist.action.batchDownload': 'Scarica',
  'filelist.action.batchDelete': 'Elimina',
  'filelist.action.download': 'Scarica',
  'filelist.action.preview': 'Anteprima',
  'filelist.action.rename': 'Rinomina',
  'filelist.selected': '{count} selezionati',
  'page.cloudDrive.title': 'Il mio Cloud Drive',
  'page.cloudDrive.description': 'MyStorageX Cloud Drive - Archivia e gestisci i tuoi file in modo sicuro',
  'modal.fileUpload.title': 'Carica file',
  'modal.fileUpload.dragText': 'Trascina i file qui o clicca per caricare',
  'modal.fileUpload.start': 'Avvia caricamento',
  'modal.fileUpload.cancel': 'Annulla',
  'modal.fileUpload.clear': 'Svuota lista',
  'modal.fileUpload.encrypt': 'Cripta selezionati',
  'modal.fileUpload.addMore': 'Aggiungi',
  'modal.fileUpload.remove': 'Rimuovi',
  'modal.fileUpload.error.noSelection': 'Seleziona i file da rimuovere',
  'modal.fileUpload.error.noEncryption': 'Seleziona i file da criptare',
  'modal.fileUpload.error.noClear': 'Nessun file da cancellare',
  'modal.fileUpload.error.noStart': 'Nessun file da caricare',
  'modal.fileUpload.error.noCancel': 'Nessun caricamento in corso da annullare',
  'modal.fileUpload.error.fileSize': 'Dimensione file superata',
  'modal.fileUpload.error.fileType': 'Tipo di file non supportato',
  'modal.fileUpload.error.maxCount': 'Numero massimo di file superato',
  'modal.fileUpload.duplicate.title': 'Il file esiste già',
  'modal.fileUpload.duplicate.skip': 'Salta',
  'modal.fileUpload.duplicate.replace': 'Sostituisci',
  'modal.fileUpload.duplicate.rename': 'Rinomina',
  'modal.fileUpload.status.pending': 'In attesa',
  'modal.fileUpload.status.uploading': 'Caricamento in corso',
  'modal.fileUpload.status.success': 'Completato',
  'modal.fileUpload.status.error': 'Errore',
  'modal.fileUpload.status.cancelled': 'Annullato',
  'modal.fileUpload.status.duplicated': 'Duplicato',
  'modal.fileUpload.table.filename': 'Nome file',
  'modal.fileUpload.table.size': 'Dimensione',
  'modal.fileUpload.table.status': 'Stato',
  'modal.fileUpload.table.progress': 'Avanzamento',
  'modal.fileUpload.table.actions': 'Azioni',
  'modal.fileUpload.speed': 'Velocità di caricamento',
  'modal.fileUpload.remainingTime': 'Tempo rimanente',
  'modal.fileUpload.total.progress': 'Avanzamento totale',
  'modal.fileUpload.error.message': 'Errore di caricamento: {message}',
  'modal.fileUpload.confirm.clear': 'Vuoi svuotare la lista di caricamento?',
  'modal.fileUpload.confirm.cancel': 'Vuoi annullare il caricamento?',
  'modal.fileUpload.clear.mobile': 'Svuota',
  'modal.fileUpload.encrypt.mobile': 'Cripta',
  'modal.fileUpload.addMore.mobile': 'Aggiungi',
  'productLog.title': 'Aggiornamenti del prodotto',
  'decrypt.fileList.column.name': 'Nome file',
  'decrypt.fileList.column.status': 'Stato',
  'decrypt.fileList.column.actions': 'Azioni',
  'decrypt.fileList.status.pending': 'In attesa',
  'decrypt.fileList.status.decrypting': 'Decrittazione in corso',
  'decrypt.fileList.status.success': 'Completato',
  'decrypt.fileList.status.error': 'Errore',
  'decrypt.fileList.action.info': 'Info',
  'decrypt.fileList.empty': 'Nessun file, aggiungi file da decrittare',
  'common.unknown': 'Sconosciuto',
  'common.speed': 'Velocità',
  'common.timeSpent': 'Tempo trascorso',
  'common.remaining': 'Rimanente',
  'security.features.title': 'Funzionalità di sicurezza',
  'security.features.localDecryption.title': 'Decrittazione locale',
  'security.features.localDecryption.description': 'Tutte le operazioni di decrittazione vengono eseguite localmente nel tuo browser, il contenuto del file e la password non lasciano mai il tuo dispositivo',
  'security.features.militaryEncryption.title': 'Crittografia militare',
  'security.features.militaryEncryption.description': 'Utilizza l\'algoritmo di crittografia AES-256-CBC, lo standard di crittografia simmetrica più sicuro che può resistere a tutti gli attacchi noti',
  'security.features.privacyProtection.title': 'Protezione della privacy',
  'security.features.privacyProtection.description': 'Meccanismo rigoroso di protezione della privacy, nessuna password di decrittazione viene salvata, nessun contenuto del file viene registrato',
  'security.features.smartDecryption.title': 'Decrittazione intelligente a blocchi',
  'security.features.smartDecryption.description': 'La tecnologia di decrittazione intelligente a blocchi migliora significativamente la velocità di decrittazione riducendo l\'utilizzo della memoria',
  'security.features.learnMore': 'Scopri di più',
  'security.features.modal.title': 'Dettagli funzionalità di sicurezza',
  'security.features.modal.close': 'Chiudi',
  'decrypt.security.modal.title': 'Avviso di sicurezza',
  'decrypt.security.modal.description': 'Tutte le operazioni di decrittazione vengono eseguite localmente, la tua password e il contenuto del file non verranno mai inviati al server',
  'decrypt.security.modal.vip.title': 'Come utente VIP, puoi:',
  'decrypt.security.modal.vip.feature1': 'Decrittare file di qualsiasi dimensione',
  'decrypt.security.modal.vip.feature2': 'Usare la decrittazione intelligente a blocchi per una migliore efficienza',
  'decrypt.security.modal.vip.feature3': 'Supportare la decrittazione in batch di file di grandi dimensioni',
  'decrypt.security.modal.free.title': 'Importante: Il processo di decrittazione richiede circa 3 volte la dimensione del file in memoria del browser.',
  'decrypt.security.modal.free.feature1': 'Gli utenti gratuiti sono limitati a 4GB per file',
  'decrypt.security.modal.free.feature2': 'Passa a VIP per decrittare file di qualsiasi dimensione',
  'decrypt.security.modal.free.feature3': 'Se il browser si blocca, considera di passare a VIP per utilizzare la decrittazione a blocchi',
  'security.diagram.plaintext.block1': 'Blocco di testo in chiaro 1',
  'security.diagram.plaintext.block2': 'Blocco di testo in chiaro 2',
  'security.diagram.ciphertext.block1': 'Blocco di testo cifrato 1',
  'security.diagram.ciphertext.block2': 'Blocco di testo cifrato 2',
  'security.diagram.key': 'Chiave',
  'security.diagram.aes.encryption': 'Crittografia AES',
  'security.diagram.xor.operation': 'Operazione XOR',
  'security.diagram.iv': 'Vettore di inizializzazione',
  'decrypt.upload.dragText': 'Clicca o trascina i file',
  'decrypt.upload.hint': 'Supporta file .encrypted, massimo {maxSize} per file',
  'decrypt.upload.button.decrypt': 'Decripta selezionati',
  'decrypt.upload.button.clear': 'Svuota lista',
  'page.decrypt.title': 'Strumento di decrittazione file MyStorage',
  'page.decrypt.subtitle': 'Decripta i tuoi file in modo sicuro',
  'page.decrypt.helmet.title': 'Strumento di decrittazione - MyStorage',
  'page.decrypt.helmet.description': 'Strumento sicuro di decrittazione - Decripta i tuoi file localmente nel browser per proteggere la tua privacy',
  'decrypt.fileInfo.modal.title': 'Informazioni File',
  'decrypt.fileInfo.modal.close': 'Chiudi',
  'decrypt.fileInfo.name': 'Nome File',
  'decrypt.fileInfo.size': 'Dimensione File',
  'decrypt.fileInfo.type': 'Tipo File',
  'decrypt.fileInfo.lastModified': 'Ultima Modifica',
  'decrypt.fileInfo.status': 'Stato',
  'decrypt.fileInfo.progress': 'Progresso',
  'decrypt.fileInfo.speed': 'Velocità',
  'decrypt.fileInfo.timeRemaining': 'Tempo Rimanente',
  'decrypt.fileInfo.timeSpent': 'Tempo Trascorso',
  'decrypt.fileInfo.error': 'Messaggio di Errore',
  'decrypt.password.modal.title': 'Inserisci password di decrittazione',
  'decrypt.password.modal.placeholder': 'Inserisci password',
  'decrypt.password.modal.hint': 'Inserisci la password impostata durante la crittazione, verrà usata solo per la decrittazione locale',
  'decrypt.message.invalidFile': 'Seleziona solo file .encrypted',
  'decrypt.message.duplicate': 'Il file "{filename}" esiste già, duplicato rimosso automaticamente',
  'decrypt.message.oversizeTitle': 'Dimensione file superata',
  'decrypt.message.oversizeContent': 'I seguenti file superano il limite gratuito (4GB):',
  'decrypt.message.oversizeHint': 'Passa a VIP per decrittare file di qualsiasi dimensione',
  'decrypt.message.selectFile': 'Seleziona i file da decrittare',
  'decrypt.message.enterPassword': 'Inserisci la password di decrittazione',
  'decrypt.message.decryptSuccess': 'Il file {filename} è stato salvato',
  'decrypt.message.saveCancel': 'Salvataggio del file {filename} annullato',
  'decrypt.message.downloadSuccess': 'Il file {filename} è stato salvato nella cartella download',
  'decrypt.message.decryptError': 'Errore durante la decrittazione del file {filename}: {error}',
  'decrypt.message.batchError': 'Decrittazione in batch fallita, riprova',
  'sideMenu.storageInfo.title': 'Spazio di archiviazione',
  'sideMenu.storageInfo.usage': 'Utilizzato {used} / Totale {total}',
  'sideMenu.storageStats.title': 'Statistiche di archiviazione',
  'sideMenu.storageStats.overview': 'Panoramica',
  'sideMenu.storageStats.totalFiles': 'Totale file',
  'sideMenu.storageStats.totalSize': 'Dimensione totale',
  'sideMenu.storageStats.fileTypes': 'Distribuzione tipi di file',
  'sideMenu.storageStats.providers': 'Fornitori di servizi',
  'common.default': 'Predefinito',
  'common.regionCode': 'Codice regione',
  'common.nodeType': 'Tipo di nodo',
  'common.storageUsed': 'Spazio utilizzato',
  'common.storageAvailable': 'Spazio disponibile',
  'common.storageLimit': 'Capacità totale',
  'common.storageUsageDetail': 'Utilizzato {used} / Totale {total}',
  'common.defaultNode': 'Nodo predefinito',
  'common.confirm': 'Conferma',
  'common.cancel': 'Annulla',
  'common.latency': 'Latenza',
  'common.retry': 'Riprova',
  'cloudDrive.nodeSelect.title': 'Seleziona nodo di archiviazione',
  'cloudDrive.nodeSelect.addNode': 'Aggiungi nodo di archiviazione',
  'cloudDrive.nodeSelect.deleteConfirm.title': 'Conferma eliminazione nodo',
  'cloudDrive.nodeSelect.deleteConfirm.content': 'Sei sicuro di voler eliminare il nodo "{nodeName}"? Questa azione non può essere annullata!',
  'cloudDrive.nodeSelect.deleteSuccess': 'Nodo eliminato con successo',
  'cloudDrive.nodeSelect.deleteFailed': 'Errore durante l\'eliminazione del nodo',
  
  // Creazione nodo
  'cloudDrive.nodeCreate.title': 'Aggiungi nodo di archiviazione',
  'cloudDrive.nodeCreate.selectProvider': 'Seleziona fornitore cloud',
  'cloudDrive.nodeCreate.nodeName': 'Nome del nodo',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': 'Lasciare vuoto per utilizzare il nome predefinito',
  'cloudDrive.nodeCreate.nameMaxLength': 'Il nome del nodo non può superare i 50 caratteri',
  'cloudDrive.nodeCreate.noProviders': 'Nessun fornitore cloud disponibile',
  'cloudDrive.nodeCreate.pingLatency': 'Latenza {value} ms',
  'cloudDrive.nodeCreate.pingTesting': 'Test della latenza in corso...',
  'cloudDrive.nodeCreate.pingFailed': 'Test della latenza fallito',
  'cloudDrive.nodeCreate.pingUnavailable': 'Test della latenza non disponibile',
  'cloudDrive.nodeCreate.sortByLatency': 'Ordina per latenza',
  'cloudDrive.nodeCreate.selectRegion': 'Seleziona regione',
  'cloudDrive.nodeCreate.selectedRegion': 'Regione selezionata',
  'cloudDrive.nodeCreate.noRegions': 'Nessuna regione disponibile',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': 'Seleziona un fornitore cloud',
  'cloudDrive.nodeCreate.selectProviderRequired': 'Seleziona prima un fornitore cloud',
  'cloudDrive.nodeCreate.selectRegionRequired': 'Seleziona prima una regione',
  'cloudDrive.nodeCreate.loadProvidersFailed': 'Errore nel caricamento della lista dei fornitori cloud',
  'cloudDrive.nodeCreate.loadRegionsFailed': 'Errore nel caricamento della lista delle regioni',
  'cloudDrive.nodeCreate.nodeType': 'Tipo di nodo',
  'cloudDrive.nodeCreate.nodeType.standard': 'Archiviazione standard',
  'cloudDrive.nodeCreate.nodeType.lowFreq': 'Archiviazione a bassa frequenza',
  'cloudDrive.nodeCreate.nodeType.archive': 'Archiviazione di archivio',
  'cloudDrive.nodeCreate.storageLimit': 'Limite di archiviazione',
  'cloudDrive.nodeCreate.storageLimitRequired': 'Inserisci il limite di archiviazione',
  'cloudDrive.nodeCreate.storageLimitMin': 'Il limite di archiviazione non può essere inferiore a 1GB',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': 'Inserisci il limite di archiviazione (GB)',
  'cloudDrive.nodeCreate.success': 'Nodo di archiviazione creato con successo',
  'cloudDrive.nodeCreate.failed': 'Errore nella creazione del nodo di archiviazione',
  
  // Modifica nodo
  'cloudDrive.nodeEdit.title': 'Modifica nodo',
  'cloudDrive.nodeEdit.name': 'Nome del nodo',
  'cloudDrive.nodeEdit.nameRequired': 'Inserisci il nome del nodo',
  'cloudDrive.nodeEdit.nameMaxLength': 'Il nome del nodo non può superare i 50 caratteri'
}; 